module.exports = __webpack_public_path__ + "static/media/sentry-safe-logo.39dd1990.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/sentry-safe-logo.png
// module id = 1304
// module chunks = 0